jQuery(document).on('click', ".zrx-cart-order-note-toggle", function() {
   //jQuery('.zrx-cart-order-note').attr('maxlength','25');
   jQuery('.zrx-cart-order-note').attr('placeholder', 'Gift note: Our limit is 20 words. Checkout button will activate once your note is added.');


});
$(window).on("load", function() {
   var giftnote = [];
   $(".zrx-product-title").each(function() {
      var title = $(this).text();
      console.log(title);
      if (title == 'Gift Note') {
         giftnote.push(title);
      }

   });
   console.log(giftnote[0]);
   var order_note = $(".zrx-cart-order-note").text();
   if (typeof giftnote[0] != 'undefined' && order_note == '') {
      $(".zrx-cart-checkout-btn").attr("disabled", "disabled");
      $(".ordernote-error").remove();
      $(".zrx-cart-order-note-wrapper").prepend("<div class='ordernote-error'>Please Fill Order Note</div>");
   }
});
$(document).on('click', ".zrx-cart-item-close-btn", function() {
   var gift = $(this).closest(".zrx-cart-item").find(".zrx-product-title").text();
   if (gift == 'Gift Note') {
      $(".zrx-cart-checkout-btn").removeAttr("disabled");
      $(".ordernote-error").remove();
   }
})
jQuery(document).on('keyup', ".zrx-cart-order-note", function() {
   var giftnote = [];
   $(".zrx-product-title").each(function() {
      var title = $(this).text();
      if (title == 'Gift Note') {
         giftnote.push(title);
      }
   });
   var words = 0;

   if ((this.value.match(/\S+/g)) != null) {
      words = this.value.match(/\S+/g).length;
   }

   if (words > 25) {

      var trimmed = $(this).val().split(/\s+/, 25).join(" ");
      jQuery(this).val(trimmed + " ");
   }
   if (typeof giftnote[0] != 'undefined' && words == 0) {
      $(".zrx-cart-checkout-btn").attr("disabled", "disabled");
      $(".ordernote-error").remove();
      $(".zrx-cart-order-note-wrapper").prepend("<div class='ordernote-error'>Please Fill Order Note</div>");
   } else {
      $(".zrx-cart-checkout-btn").removeAttr("disabled");
      $(".ordernote-error").remove();
   }
});
$(document).on('click', ".zrx-tb-box-cart-item", function() {
   console.log("ghfgh");

   var order_note = $(".zrx-cart-order-note").text();
   console.log(order_note);
   if (order_note == '') {
      $(".ordernote-error").remove();
      $(".zrx-cart-order-note-wrapper").prepend("<div class='ordernote-error'>Please Fill Order Note</div>");
      $(".zrx-cart-checkout-btn").attr("disabled", "disabled");
   } else {
      $(".ordernote-error").remove();
      $(".zrx-cart-checkout-btn").remove("disabled", "disabled");
   }
})


$(document).on("click", ".zrx-cart-plus", function() {
   var giftnote = [];
   $(".zrx-product-title").each(function() {
      var title = $(this).text();
      console.log(title);
      if (title == 'Gift Note') {
         giftnote.push(title);
      }

   });
   var qty = $(this).closest(".zrx-cart-quantity-inner").find(".zrx-cart-item-qty").text();
   var gift = $(this).closest(".zrx-cart-item-description").find(".zrx-product-title").text();
   if (gift == 'Gift Note' && typeof giftnote[0] == 'undefined') {
      $(".zrx-cart-checkout-btn").removeAttr("disabled");
      $(".ordernote-error").remove();
   }
});






/**
 * to exclude Hand Written Gift Notes from Digital Products 
 * This script intercepts cart updates and dynamically updates the visibility of the cart note section
 * based on the presence of non-digital products. It uses custom events provided by the theme to 
 * ensure the cart note visibility is updated correctly.
body[data-has-non-digital-product="false"] .zrx-order-note,
body[data-has-non-digital-product="false"] textarea[name="note"], 
body[data-has-non-digital-product="false"] label[for="CartNote"] {
  display: none;
}
 *
 * This script handles the visibility and requirements of the cart note section based on the contents of the cart.
 * Specifically, it ensures that if a "Gift Note" product is in the cart, the user must fill out the order note 
 * before proceeding to checkout. The script dynamically updates the UI by disabling the checkout button and 
 * displaying an error message until the note is filled.
 *
 * Additional features:
 * - Intercepts cart-related fetch requests to monitor and trigger custom events for updating the cart.
 * - Ensures the cart note section is only visible when there are non-digital products in the cart.
 * - Utilizes MutationObserver to monitor changes in the cart items container and updates the cart note visibility accordingly.
 * */

let isUpdatingCart = false;
let observer;
let mutationTimeout;

(function(ns, fetch) {
   if (typeof fetch !== 'function') return;

   ns.fetch = function() {
      const response = fetch.apply(this, arguments);

      response.then(res => {
         if ([
               `${window.location.origin}/cart/add.js`,
               `${window.location.origin}/cart/update.js`,
               `${window.location.origin}/cart/change.js`,
               `${window.location.origin}/cart/clear.js`,
            ].includes(res.url)) {
            res.clone().json().then(data => {
               if (!isUpdatingCart) {
                  document.dispatchEvent(new Event('cart:build'));
               }
            });
         }
      });

      return response;
   }

}(window, window.fetch));

// Function to update the visibility of the cart note section based on cart contents
function updateCartNoteVisibility() {
   var hasNonDigitalProduct = false;
   var hasGiftNote = false;

   isUpdatingCart = true;

   // Check each cart item for the 'requires_shipping' attribute and if "Gift Note" is in the cart
   fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
         cart.items.forEach(item => {
            if (item.requires_shipping) {
               hasNonDigitalProduct = true;
            }
            if (item.title.includes("Gift Note")) {
               hasGiftNote = true;
            }
         });

         // Update the data attribute on the body tag
         document.body.setAttribute('data-has-non-digital-product', hasNonDigitalProduct);
         document.body.setAttribute('data-has-gift-note', hasGiftNote);

         // Handle Gift Note specific behavior
         enforceOrderNoteRequirement(hasGiftNote);

         isUpdatingCart = false;
      })
      .catch(error => {
         isUpdatingCart = false;
      });
}

// Function to enforce the order note requirement when "Gift Note" is in the cart
function enforceOrderNoteRequirement(hasGiftNote) {
   const cartPageDiv = document.querySelector('.cart__page');
   if (!cartPageDiv) return;

   const checkoutButton = cartPageDiv.querySelector('button[name="checkout"]');
   const orderNoteTextarea = cartPageDiv.querySelector('textarea[name="note"]');
   const orderNoteLabel = cartPageDiv.querySelector('label[for="CartNote"]');
   let existingErrorText = cartPageDiv.querySelector('.order-note-error');

   if (hasGiftNote) {
      // Display prompt and disable checkout if note is empty
      if (orderNoteTextarea && orderNoteTextarea.value.trim() === "") {
         console.log('Order note is empty, disabling checkout.');
         if (!existingErrorText) {
            const errorText = document.createElement('p');
            errorText.classList.add('order-note-error');
            errorText.textContent = "Please Fill Order Note";
            orderNoteLabel.insertAdjacentElement('afterend', errorText);
         }
         checkoutButton.disabled = true;
      }

      // Add an event listener to log the order note textarea content and enable checkout
      orderNoteTextarea.addEventListener('input', function() {
         console.log('Order note textarea content:', this.value.trim());
         if (this.value.trim() !== "") {
            console.log('Order note filled, enabling checkout.');
            checkoutButton.disabled = false;
            existingErrorText = cartPageDiv.querySelector('.order-note-error');
            if (existingErrorText) {
               existingErrorText.remove();
            }
         } else {
            console.log('Order note emptied, disabling checkout.');
            checkoutButton.disabled = true;
            if (!cartPageDiv.querySelector('.order-note-error')) {
               const errorText = document.createElement('p');
               errorText.classList.add('order-note-error');
               errorText.textContent = "Please Fill Order Note";
               orderNoteLabel.insertAdjacentElement('afterend', errorText);
            }
         }
      });
   } else {
      console.log('Gift Note not in cart, checkout is enabled.');
      checkoutButton.disabled = false;
      if (existingErrorText) {
         existingErrorText.remove();
      }
   }
}

// Initial check on page load based on the data attribute
document.addEventListener('DOMContentLoaded', function() {
   console.log('DOM fully loaded and parsed.');
   updateCartNoteVisibility();
});

// Listen for the custom cart build event
document.addEventListener('cart:build', function() {
   console.log('Custom event cart:build triggered.');
   updateCartNoteVisibility();
});

// Listen for cart quantity changes and updates
document.addEventListener('cart:updated', function() {
   console.log('Event cart:updated triggered.');
   updateCartNoteVisibility();
});

// Listen for custom cart events
document.addEventListener('cart:quantity', function() {
   console.log('Event cart:quantity triggered.');
   updateCartNoteVisibility();
});

// Listen for changes in the cart drawer to detect quantity changes and product removals
document.addEventListener('cart:refresh', function() {
   console.log('Event cart:refresh triggered.');
   updateCartNoteVisibility();
});

// Set up a MutationObserver to monitor changes within .zrx-cart-items
const observeCartItems = () => {
   const targetNode = document.querySelector('.zrx-cart-items');
   if (targetNode) {
      const config = { childList: true, subtree: true };

      const callback = function(mutationsList, observer) {
         clearTimeout(mutationTimeout);
         mutationTimeout = setTimeout(function() {
            console.log('Mutation observed in .zrx-cart-items.');
            updateCartNoteVisibility();
            observer.disconnect(); // Stop observing after the update
         }, 600); // Delay of 600ms after the last mutation
      };

      observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
   }
};

// Listen for clicks on .zrx-cart-item-close-btn, .zrx-cart-minus, and .zrx-cart-plus
document.addEventListener('click', function(event) {
   if (event.target.closest('.zrx-cart-item-close-btn') ||
      event.target.closest('.zrx-cart-minus') ||
      event.target.closest('.zrx-cart-plus')) {
      console.log('Cart item quantity or removal button clicked.');
      observeCartItems();
   }
});



// snippets/search-results.liquid
// sections/main-search.liquid
// This script dynamically updates the search result count in the breadcrumb, page title, and collection filter count
// based on the global variable `window.filteredProductCount`, which is set in the main-search.liquid template.
document.addEventListener("DOMContentLoaded", function() {
    // Check if window.filteredProductCount is available and is a valid number
    if (typeof window.filteredProductCount === 'number' && !isNaN(window.filteredProductCount)) {
        
        // Select all span elements within the breadcrumb navigation
        var breadcrumbSpans = document.querySelectorAll('.breadcrumb span');

        // Loop through the span elements to find the one containing "Search:"
        breadcrumbSpans.forEach(function(span) {
            if (span.textContent.trim().startsWith('Search:')) {
                span.textContent = span.textContent.replace(/\d+ results found/, window.filteredProductCount + ' results found');
            }
        });

        // Update the document title
        document.title = document.title.replace(/\d+ results found/, window.filteredProductCount + ' results found');

        // Update the collection filter count
        var filterCountDiv = document.querySelector('.collection-filter__item--count');
        if (filterCountDiv) {
            filterCountDiv.textContent = filterCountDiv.textContent.replace(/\d+ results/, window.filteredProductCount + ' results');
        }
    }
});


// wlm: if logged in wholesale user then add the class "wlm-logged-in" to the body
// to show/hide wholesale product
// Check if any `lcid` exists and then add the class to the body
// document.addEventListener("DOMContentLoaded", function() {
//   if (wlm.navigateListByAuth && wlm.navigateListByAuth.may.some(auth => 'lcid' in auth)) {
//     document.body.classList.add('wlm-logged-in');
//   }
// });
